import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { HmacUtil } from 'src/app/shared/helpers';
import { environment } from 'src/environments/environment';

@Injectable()
export class HmacInterceptor implements HttpInterceptor {

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    // Only protect specific APIs
    if (!this.requiresHmac(request.url)) {
      return next.handle(request);
    }

    const timestamp = Math.floor(Date.now() / 1000).toString();

    return from(
      HmacUtil.generateHmacBase64(timestamp, environment.hmacSecretKey)
    ).pipe(
      switchMap(signature => {
        const signedRequest = request.clone({
          setHeaders: {
            'X-HMAC-Timestamp': timestamp,
            'X-HMAC-Signature': signature
          }
        });
        return next.handle(signedRequest);
      })
    );
  }

  private requiresHmac(url: string): boolean {
    // v1 intent-trial endpoints use HMAC; the v2 domain-topics endpoint uses session auth, so skip it.
    return url.includes('/intenttrial') && !url.includes('/intenttrial/domain-topics/v2');
  }
}
